// extracted by mini-css-extract-plugin
module.exports = {"station-container":"Station_station-container__2mk2y","fallback":"Station_fallback__2WqIF"};